export default __webpack_public_path__ + "static/media/PD active.979ad310.svg";